export default __webpack_public_path__ + "static/media/Toyota_Fortuna_Fix.b862471c.png";